import React from 'react';
import { motion } from 'framer-motion';
import { tomos } from '../data/salesData';
export function TomosSection() {
  return <section className="py-16 px-4 bg-surface-light" data-id="element-278">
      <div className="max-w-6xl mx-auto" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-280">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-281">
            Los 12 Tomos Completos
          </h2>
          <p className="text-lg text-gray-600" data-id="element-282">
            Secuencias graficadas · Por nivel y objetivo · Listo para usar
            mañana
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-283">
          {tomos.map((tomo, index) => <motion.div key={tomo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index % 2 * 0.1
        }} className={`p-6 rounded-lg border-2 ${index % 2 === 0 ? 'bg-white border-gray-200' : 'bg-surface-accent border-gray-200'}`} data-id="element-284">
              <div className="flex items-start gap-4" data-id="element-285">
                <div className="w-12 h-12 rounded-lg bg-primary text-white flex items-center justify-center font-bold text-xl flex-shrink-0" data-id="element-286">
                  {tomo.number}
                </div>
                <div className="flex-1" data-id="element-287">
                  <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-288">
                    TOMO {tomo.number}
                  </h3>
                  <h4 className="text-lg font-semibold text-accent mb-2" data-id="element-289">
                    {tomo.title}
                  </h4>
                  {tomo.weeks && <p className="text-sm text-gray-500 font-medium mb-2" data-id="element-290">
                      ({tomo.weeks})
                    </p>}
                  <p className="text-gray-700" data-id="element-291">{tomo.description}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center bg-white p-6 rounded-xl shadow-sm" data-id="element-292">
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-293">
            <span data-id="element-294">✏️</span>
            <span className="text-sm font-semibold" data-id="element-295">
              Ejercicios graficados en cada tomo
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-296">
            <span data-id="element-297">⚡</span>
            <span className="text-sm font-semibold" data-id="element-298">
              Sistema "Abrí y Dictás"
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-299">
            <span data-id="element-300">📋</span>
            <span className="text-sm font-semibold" data-id="element-301">
              Fichas listas para imprimir
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-302">
            <span data-id="element-303">🇦🇷</span>
            <span className="text-sm font-semibold" data-id="element-304">
              Contenido 100% adaptado a Argentina
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}